function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["regionCode"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import distributionRegionMixin from '@/mixins/distributionRegion';
import request from '@/utils/request';
import { getLeaderList, getLeaderApplyList, getApplicantConditions, approveLeaderApply, approveAllLeaderApplies, unbindLeaderAgent } from '@/api/distributionAlliance';
var cityListTree = function cityListTree() {
  return request({
    url: '/admin/merchant/city/region/city/tree',
    method: 'get'
  });
};
export default {
  mixins: [distributionRegionMixin],
  name: 'AllianceLeader',
  data: function data() {
    return {
      tab: 'leader',
      // 三级树直接喂给级联选择器：拍平成几千个 option 塞进 el-select 会把页面卡死
      cityOptions: [],
      cascaderProps: {
        value: 'id',
        label: 'name',
        children: 'child',
        checkStrictly: true,
        emitPath: true
      },
      regionNameMap: {},
      leaderRegionIds: [],
      applyRegionIds: [],
      leaderList: [],
      leaderTotal: 0,
      leaderLoading: false,
      applyList: [],
      applyTotal: 0,
      applyLoading: false,
      batchApproving: false,
      // 按 uid 缓存达标情况：同一个人可能在列表里被反复点开，没必要每次都跑一遍规则
      conditionCache: {},
      conditionLoading: false,
      leaderUsers: {},
      leaderQuery: {
        regionCode: '',
        contact: '',
        auditStatus: null,
        agentId: null,
        page: 1,
        size: 20
      },
      applyQuery: {
        regionCode: '',
        contact: '',
        status: undefined,
        page: 1,
        size: 20
      },
      // 状态码与后端 LeaderService 里的常量一一对应，改一边要同步改另一边
      applyStatusOptions: [{
        value: 0,
        label: '待审批'
      }, {
        value: 1,
        label: '已通过'
      }, {
        value: 2,
        label: '已驳回'
      }, {
        value: 3,
        label: '已撤回'
      }, {
        value: 4,
        label: '平台否决'
      }]
    };
  },
  created: function created() {
    this.loadCityTree();
    // 「区域与代理」页点「查看」跳过来时带着 agentId，直接筛成那个代理名下的团长
    var agentId = this.$route.query && this.$route.query.agentId;
    if (agentId) this.leaderQuery.agentId = Number(agentId) || null;
    this.loadLeaders(1);
  },
  methods: {
    loadCityTree: function () {
      var _loadCityTree = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, list, nameMap, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return cityListTree();
            case 1:
              res = _context.v;
              list = Array.isArray(res) ? res : res && res.list || [];
              nameMap = {};
              this.cityOptions = this.normalizeTree(list, 1, nameMap);
              // 整体赋值，Vue 2 里逐 key 写入不会触发视图更新
              this.regionNameMap = nameMap;
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              this.cityOptions = [];
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function loadCityTree() {
        return _loadCityTree.apply(this, arguments);
      }
      return loadCityTree;
    }(),
    // 最多下钻三级（省/市/区），顺手记下 code -> 名称，列表里才好显示中文
    normalizeTree: function normalizeTree(list) {
      var _this = this;
      var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var nameMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!Array.isArray(list)) return [];
      return list.map(function (n) {
        var item = {
          id: String(n.regionId != null ? n.regionId : n.id),
          name: n.regionName || n.name
        };
        nameMap[item.id] = item.name;
        var children = n.child || n.children;
        if (depth < 3 && Array.isArray(children) && children.length) item.child = _this.normalizeTree(children, depth + 1, nameMap);
        return item;
      });
    },
    onLeaderRegionChange: function onLeaderRegionChange(value) {
      this.leaderQuery.regionCode = value && value.length ? value[value.length - 1] : '';
    },
    onApplyRegionChange: function onApplyRegionChange(value) {
      this.applyQuery.regionCode = value && value.length ? value[value.length - 1] : '';
    },
    clean: function clean(q) {
      return Object.keys(q).reduce(function (o, k) {
        if (q[k] !== '' && q[k] !== null && q[k] !== undefined) o[k] = q[k];
        return o;
      }, {});
    },
    userName: function userName(uid) {
      var u = this.leaderUsers[uid];
      return u && u.nickname ? u.nickname : "\u7528\u6237".concat(uid || '');
    },
    contact: function contact(uid) {
      var u = this.leaderUsers[uid];
      return u && u.phone ? u.phone : '-';
    },
    regionName: function regionName(code) {
      return this.regionNameMap[String(code)] || code || '-';
    },
    money: function money(v) {
      return Number(v || 0).toFixed(2);
    },
    loadLeaders: function loadLeaders(p) {
      var _this2 = this;
      if (p) this.leaderQuery.page = Number(p);
      this.leaderLoading = true;
      // 后端收的是 regionPrefix（按区域编码前缀匹配，省/市/区都能筛），
      // 原来直接把 regionCode 发过去，那个参数后端根本不认 —— 城市筛选一直是摆设
      var _this$leaderQuery = this.leaderQuery,
        regionCode = _this$leaderQuery.regionCode,
        rest = _objectWithoutProperties(_this$leaderQuery, _excluded);
      var params = this.clean(_objectSpread(_objectSpread({}, rest), {}, {
        regionPrefix: regionCode
      }));
      getLeaderList(params).then(function (r) {
        _this2.leaderList = r && r.list || [];
        _this2.leaderUsers = r && r.users || {};
        _this2.leaderTotal = Number(r && r.total) || 0;
      }).catch(function () {
        _this2.$message.error('团长业绩加载失败');
      }).finally(function () {
        _this2.leaderLoading = false;
      });
    },
    loadApplies: function loadApplies(p) {
      var _this3 = this;
      if (p) this.applyQuery.page = Number(p);
      this.applyLoading = true;
      getLeaderApplyList(this.clean(this.applyQuery)).then(function (r) {
        _this3.applyList = r && r.list || [];
        _this3.applyTotal = Number(r && r.total) || 0;
      }).catch(function () {
        _this3.$message.error('团长申请加载失败');
      }).finally(function () {
        _this3.applyLoading = false;
      });
    },
    onTabChange: function onTabChange() {
      if (this.tab === 'apply' && !this.applyList.length) this.loadApplies(1);
    },
    resetLeaders: function resetLeaders() {
      this.leaderRegionIds = [];
      // 重置保留 agentId：从「区域与代理」点「查看」跳过来时，重置查询条件
      // 不该顺手把「只看这个代理名下」也清掉 —— 那样用户会以为跳转失效了
      this.leaderQuery = {
        regionCode: '',
        contact: '',
        auditStatus: null,
        agentId: this.leaderQuery.agentId,
        page: 1,
        size: 20
      };
      this.loadLeaders(1);
    },
    clearAgentFilter: function clearAgentFilter() {
      this.leaderQuery.agentId = null;
      this.loadLeaders(1);
    },
    /**
     * 解除团长与区域代理的管理绑定。
     *
     * 只摘管理关系，团长身份、推广码、团员、历史订单与已产生的佣金全部保留 ——
     * 想停掉一个人的团长身份走的是另一条路（平台否决）。
     *
     * 解绑之后：该团长的申请不再由原代理审批、不再计入原代理的名下团长数；
     * 「按分享链路」口径下这一单的代理分成会回落到收货地判定。
     * 历史订单在支付成功时已固化归属，不回溯。
     */
    unbindAgent: function unbindAgent(row) {
      var _this4 = this;
      var name = this.userName(row.uid);
      this.$prompt("\u5C06\u300C".concat(name, "\u300D\u4ECE\u4EE3\u7406 #").concat(row.agentId, " \u540D\u4E0B\u89E3\u7ED1\u3002\u56E2\u957F\u8EAB\u4EFD\u3001\u63A8\u5E7F\u7801\u3001\u56E2\u5458\u4E0E\u5386\u53F2\u4F63\u91D1\u90FD\u4FDD\u7559\uFF0C") + '此后不再由该代理审批与统计；已产生的订单分账不回溯。', '解绑代理', {
        confirmButtonText: '确定解绑',
        cancelButtonText: '取消',
        inputPlaceholder: '请填写解绑原因（必填，会记进操作日志）',
        // 后端 unbindAgent 强制要求原因，这里先拦一道，省得填空了才报错
        inputValidator: function inputValidator(v) {
          return v && v.trim() ? true : '请填写解绑原因';
        }
      }).then(function (_ref) {
        var value = _ref.value;
        unbindLeaderAgent(row.uid, value.trim()).then(function () {
          _this4.$message.success('已解绑');
          _this4.loadLeaders();
        }).catch(function () {});
      }).catch(function () {});
    },
    resetApplies: function resetApplies() {
      this.applyRegionIds = [];
      this.applyQuery = {
        regionCode: '',
        contact: '',
        status: undefined,
        page: 1,
        size: 20
      };
      this.loadApplies(1);
    },
    onApplySizeChange: function onApplySizeChange(size) {
      this.applyQuery.size = size;
      this.loadApplies(1);
    },
    /**
     * 拉某个申请人当前的达标情况。
     *
     * 算的是「此刻」的值而不是提交那一刻的快照 —— 审批要判断的是「现在该不该批」：
     * 中途退款会让消费额掉下来，平台也可能在这期间把条件调严了。
     */
    loadConditions: function loadConditions(uid) {
      var _this5 = this;
      if (!uid || this.conditionCache[uid]) return;
      this.conditionLoading = true;
      getApplicantConditions(uid).then(function (res) {
        var data = res && res.items ? res : {
          items: []
        };
        _this5.$set(_this5.conditionCache, uid, data);
      }).catch(function () {
        _this5.$set(_this5.conditionCache, uid, {
          items: []
        });
      }).finally(function () {
        _this5.conditionLoading = false;
      });
    },
    approveOne: function () {
      var _approveOne = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(row) {
        var _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return this.$confirm("\u786E\u8BA4\u901A\u8FC7\u300C".concat(row.realName || row.uid, "\u300D\u7684\u56E2\u957F\u7533\u8BF7\uFF1F\u901A\u8FC7\u540E\u5BF9\u65B9\u7ACB\u5373\u6210\u4E3A\u56E2\u957F\u3002"), '提示', {
                type: 'warning'
              });
            case 1:
              _context2.n = 2;
              return approveLeaderApply(row.id);
            case 2:
              this.$message.success('已通过');
              this.loadApplies();
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 3]]);
      }));
      function approveOne(_x) {
        return _approveOne.apply(this, arguments);
      }
      return approveOne;
    }(),
    /**
     * 一键通过。后端逐条走审批流程，单条失败不影响其余，
     * 所以这里报的是「实际通过几条」而不是「全部通过」——
     * 一批里混进一个已经是团长的人，说全部通过就是骗人。
     */
    approveAll: function () {
      var _approveAll = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var scope, res, n, _t3, _t4;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              scope = this.applyQuery.regionCode ? '该区域' : '全平台';
              _context3.p = 1;
              _context3.n = 2;
              return this.$confirm("\u786E\u8BA4\u628A".concat(scope, "\u6240\u6709\u5F85\u5BA1\u6279\u7684\u56E2\u957F\u7533\u8BF7\u5168\u90E8\u901A\u8FC7\uFF1F\u901A\u8FC7\u540E\u5BF9\u65B9\u7ACB\u5373\u6210\u4E3A\u56E2\u957F\u3002"), '一键通过', {
                type: 'warning'
              });
            case 2:
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t3 = _context3.v;
              return _context3.a(2);
            case 4:
              this.batchApproving = true;
              _context3.p = 5;
              _context3.n = 6;
              return approveAllLeaderApplies(this.applyQuery.regionCode || undefined);
            case 6:
              res = _context3.v;
              n = typeof res === 'number' ? res : res && res.data || 0;
              this.$message.success("\u5DF2\u901A\u8FC7 ".concat(n, " \u6761"));
              this.conditionCache = {};
              this.loadApplies(1);
              _context3.n = 8;
              break;
            case 7:
              _context3.p = 7;
              _t4 = _context3.v;
            case 8:
              _context3.p = 8;
              this.batchApproving = false;
              return _context3.f(8);
            case 9:
              return _context3.a(2);
          }
        }, _callee3, this, [[5, 7, 8, 9], [1, 3]]);
      }));
      function approveAll() {
        return _approveAll.apply(this, arguments);
      }
      return approveAll;
    }(),
    /** 状态原来直接打印数字，运营看到一列 0/1/2 完全不知道是什么 */applyStatusText: function applyStatusText(status) {
      var hit = this.applyStatusOptions.find(function (s) {
        return s.value === Number(status);
      });
      return hit ? hit.label : String(status == null ? '-' : status);
    },
    applyStatusTag: function applyStatusTag(status) {
      return {
        0: 'warning',
        1: 'success',
        2: 'danger',
        3: 'info',
        4: 'danger'
      }[Number(status)] || 'info';
    },
    applyTypeText: function applyTypeText(type) {
      return {
        PERSONAL: '个人',
        STORE: '门店'
      }[type] || type || '-';
    }
  }
};